/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useLogoutMutation } from "../../../../store/apiSlice/authApiSlice";
import { authUser } from "../../../../store/slice/authSlice";
import { MenuComponent } from "../../../assets/ts/components";
import { toAbsoluteUrl } from "../../../helpers";

const HeaderUserMenu = () => {
  useEffect(() => {
    MenuComponent.reinitialization();
  }, []);

  const currentUser = useSelector(authUser);

  const [logout, { isLoading }] = useLogoutMutation();

  const doLogout = async () => {
    await logout();
  };

  return (
    <div
      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px"
      data-kt-menu="true"
      data-popper-placement="bottom-start"
    >
      <div className="menu-item px-3">
        <div className="menu-content d-flex align-items-center px-3">
          <div className="symbol symbol-50px me-5">
            <img alt="Logo" src={toAbsoluteUrl("/media/avatars/blank.png")} />
          </div>

          <div className="d-flex flex-column">
            <div className="fw-bolder d-flex align-items-center fs-5">
              {currentUser?.first_name} {currentUser?.last_name}
            </div>
            <div className="fw-bold text-muted text-hover-primary fs-7">{currentUser?.email}</div>
          </div>
        </div>
      </div>

      <div className="separator my-2"></div>

      <div className="menu-item px-5">
        <Link className="menu-link px-5 py-1" to="/account">
          Account
        </Link>
        <div className="separator my-2"></div>

        <a className="menu-link px-5 py-1" onClick={doLogout}>
          Sign Out
          {isLoading && (
            <span className="spinner-border spinner-border-sm text-secondary align-middle ms-2"></span>
          )}
        </a>
      </div>
    </div>
  );
};

export { HeaderUserMenu };
